import { Component, HostListener, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs';
import {
  MdbPopconfirmRef,
  MdbPopconfirmService,
} from 'mdb-angular-ui-kit/popconfirm';
import { ContactPopupComponent } from 'src/app/components';
import { HOLISTA_CONSTANT } from 'src/app/constants';
import { MainService } from 'src/app/services/main.service';
import { HolistaUtils } from 'src/app/utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  logoPath: string = 'assets/img/svg/Logo.svg';
  HOLISTA_CONSTANT = this._holistaUtils.deepClone(HOLISTA_CONSTANT);
  networkConfig: any;
  networkName: string | null;
  isDownloadDropdownOpen = false;
  isDownloading = false;
  isProd = environment.env === 'prod';

  @Input() set config(data) {
    if (data?.code) {
      this.networkConfig = data;
    }
  }

  ngOnInit() {
    this.networkName =
      'networkName' in environment
        ? (environment['networkName'] as string)
        : null;
  }

  popconfirmRef: MdbPopconfirmRef<ContactPopupComponent> | null = null;

  constructor(
    public _holistaUtils: HolistaUtils,
    private popconfirmService: MdbPopconfirmService,
    private _mainService: MainService
  ) {}

  onLinkClick(link: string, newTab?: boolean) {
    this._holistaUtils.customRedirect(link, newTab);
  }

  openContactPopup(event) {
    const target = event.target as HTMLElement;
    this.popconfirmRef = this.popconfirmService.open(
      ContactPopupComponent,
      target,
      { popconfirmMode: 'modal' }
    );
  }

  navigateToHome() {
    window.open(location.href, '_self');
  }

  toggleDownloadDropdown(event: Event) {
    event.stopPropagation();
    this.isDownloadDropdownOpen = !this.isDownloadDropdownOpen;
  }


  getReportName() {
    if(!this._mainService.providerExportQuery.type) return 'PROVIDER_DIRECTORY_REPORT';

    return this._mainService.providerExportQuery.type  === 'PHYSICIAN' ? 'Physician_Facility_Report' : 'FACILITY_SERVICE_REPORT';
  }

  onDownload(type: 'pdf' | 'excel') {
    this.isDownloadDropdownOpen = false;
    this.isDownloading = true;

    if (type === 'pdf') {
      this._mainService.exportProviderFacilityReport({
        excludeTerminatedProviders: true
      })
        .pipe(finalize(() => this.isDownloading = false))
        .subscribe((response: any) => {
          window.open(response.data.fullPath, '_blank');
        });
    } else {
      const currentDate = new Date()
      this._mainService.exportProviders({ reportType: 'PROVIDER_FACILITY_REPORT_XLSX', excludeTerminatedProviders: true })
        .pipe(finalize(() => this.isDownloading = false))
        .subscribe((blob: Blob) => {
          const file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(file);
          const anchor = document.createElement('a');
          anchor.href = url;
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const reportName = this.getReportName()
          anchor.download = `${reportName}_${currentDate.getFullYear()}-${month}-${day}.xlsx`;
          anchor.click();
          window.URL.revokeObjectURL(url);
        });
    }
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.isDownloadDropdownOpen = false;
  }
}
